import React from 'react';
import { useInView } from './useInView';
import './StatsSection.css';

const stats = [
  { number: '', label: 'Fresh & Tasty' },
  { number: '', label: 'Ecofriendly packing' },
  { number: '', label: 'Premium ingredients' },
];

const StatsSection = () => {
  const [ref, inView] = useInView();

  return (
    <section className="stats" ref={ref}>
      <div className="container">
        <div className="stats__grid">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`stat-item${inView ? ' stat-item--visible' : ''}`}
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <span className="stat-item__number">{stat.number}</span>
              <span className="stat-item__label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
